module.exports = __webpack_public_path__ + "static/media/Certificazioni.5983e428.pdf";